import { render, staticRenderFns } from "./AddPersonEmploymentDialog.vue?vue&type=template&id=36d69898&scoped=true&"
import script from "./AddPersonEmploymentDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersonEmploymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d69898",
  null
  
)

export default component.exports